import { every, get, has, some } from 'lodash';
import type { IRequestParameters } from './RequestParameters.interface';

export default class RequestParameters implements IRequestParameters {
  url: String;
  method: String;
  header: Object;
  query: Object;
  useQueryAsPayload: Boolean;

  deleteTaxing = () => {
    delete this.query.orderBy;
    delete this.query.coerceTo;
    delete this.query.isDescending;
    delete this.query.startingWith;
  };

  isTaxing = () =>
    !this.hasQueries(['isCount', 'isSum']) &&
    this.hasQueries(['orderBy', 'coerceTo', 'isDescending', 'startingWith']);

  hasQuery = (param: String, value: any = undefined) => {
    const hasQueryParam = has(this.query, param);
    if (value !== undefined) {
      const queryParamValue = get(this.query, param);
      return hasQueryParam && queryParamValue === value;
    }
    return hasQueryParam;
  };

  hasQueries = (params: Array<String>, all: Boolean) => {
    const picker = all ? every : some;
    return picker(params, (p) => this.hasQuery(p));
  };

  noTaxing = () => {
    if (this.isTaxing()) {
      const switchStartingWith =
        this.hasQuery('startingWith', '') || this.hasQuery('startingWith', 'ALL');

      this.deleteTaxing();
      if (switchStartingWith) {
        this.query.startingWith = 'A';
      }
    }
  };

  /**
   * Constructor
   * @param {IRequestParameters} data
   * @param {Boolean} noTaxing
   * @param {Boolean} reset
   */
  constructor(data?: IRequestParameters, noTaxing: Boolean = false, reset: Boolean = false) {
    this.url = data?.url || '';
    this.method = data?.method || 'GET';
    this.header = data?.header || {};
    this.query = data?.query || {};
    this.useQueryAsPayload = data?.useQueryAsPayload === true;

    if (!reset && noTaxing) {
      this.noTaxing();
    }
    if (reset) {
      this.deleteTaxing();
    }
  }
}
